export default __webpack_public_path__ + "static/media/app-icon-blue.49cdb9fd.svg";